var _require = require('crypto'),
    publicEncrypt = _require.publicEncrypt,
    privateDecrypt = _require.privateDecrypt,
    constants = _require.constants;

var _require2 = require('../help/runtime_support'),
    oaepHashSupported = _require2.oaepHashSupported;

var _require3 = require('../help/consts'),
    KEYOBJECT = _require3.KEYOBJECT;

var _require4 = require('../help/key_object'),
    asInput = _require4.asInput;

var resolvePadding = function resolvePadding(alg) {
  switch (alg) {
    case 'RSA-OAEP':
    case 'RSA-OAEP-256':
    case 'RSA-OAEP-384':
    case 'RSA-OAEP-512':
      return constants.RSA_PKCS1_OAEP_PADDING;

    case 'RSA1_5':
      return constants.RSA_PKCS1_PADDING;
  }
};

var resolveOaepHash = function resolveOaepHash(alg) {
  switch (alg) {
    case 'RSA-OAEP':
      return 'sha1';

    case 'RSA-OAEP-256':
      return 'sha256';

    case 'RSA-OAEP-384':
      return 'sha384';

    case 'RSA-OAEP-512':
      return 'sha512';

    default:
      return undefined;
  }
};

var wrapKey = function wrapKey(padding, oaepHash, _ref, payload) {
  var keyObject = _ref[KEYOBJECT];
  var key = asInput(keyObject, true);
  return {
    wrapped: publicEncrypt({
      key: key,
      oaepHash: oaepHash,
      padding: padding
    }, payload)
  };
};

var unwrapKey = function unwrapKey(padding, oaepHash, _ref2, payload) {
  var keyObject = _ref2[KEYOBJECT];
  var key = asInput(keyObject, false);
  return privateDecrypt({
    key: key,
    oaepHash: oaepHash,
    padding: padding
  }, payload);
};

var LENGTHS = {
  RSA1_5: 0,
  'RSA-OAEP': 592,
  'RSA-OAEP-256': 784,
  'RSA-OAEP-384': 1040,
  'RSA-OAEP-512': 1296
};

module.exports = function (JWA, JWK) {
  var algs = ['RSA-OAEP', 'RSA1_5'];

  if (oaepHashSupported) {
    algs.splice(1, 0, 'RSA-OAEP-256', 'RSA-OAEP-384', 'RSA-OAEP-512');
  }

  algs.forEach(function (jwaAlg) {
    var padding = resolvePadding(jwaAlg);
    var oaepHash = resolveOaepHash(jwaAlg);
    JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, padding, oaepHash));
    JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, padding, oaepHash));

    JWK.RSA.wrapKey[jwaAlg] = function (key) {
      return (key.use === 'enc' || key.use === undefined) && key.length >= LENGTHS[jwaAlg];
    };

    JWK.RSA.unwrapKey[jwaAlg] = function (key) {
      return key.private && (key.use === 'enc' || key.use === undefined) && key.length >= LENGTHS[jwaAlg];
    };
  });
};